import React from 'react';
import { LoadScript } from '@react-google-maps/api';
import { useTranslatedText } from '../i18n/useTranslatedText.js';

const libraries = ['places', 'marker'];

const MapScriptLoader = ({ children }) => {
  const loadingText = useTranslatedText('Yükleniyor...');

  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
      libraries={libraries}
      loadingElement={<div>{loadingText}</div>}
    >
      {children}
    </LoadScript>
  );
};

export default MapScriptLoader;
